import React from "react";

export default function QuickLinksMenu({
  className = "hero-quick-menu",
  label,
  secureLinks = false,
}) {
  const relProps = secureLinks ? { rel: "noopener noreferrer" } : {};
  return (
    <nav className={className} aria-label={label}>
      <a
        className="hero-quick-menu__item"
        href="https://twitter.com/nero_awab"
        target="__blank"
        {...relProps}
      >
        Twitter
      </a>
      <a
        className="hero-quick-menu__item"
        href="https://www.linkedin.com/in/nero-awab/"
        target="__blank"
        {...relProps}
      >
        LinkedIn
      </a>
      <button
        type="button"
        className="hero-quick-menu__item"
        onClick={() => {
          window.prompt(":)", "nero@awab.dev");
        }}
      >
        Email
      </button>
      <a
        className="hero-quick-menu__item hero-quick-menu__item--last"
        href="/CV1.1.pdf"
        target="__blank"
        {...relProps}
      >
        CV
      </a>
    </nav>
  );
}
